import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { GlobalStoreService } from '@lib-core/global/services/global-store.service';
import { LoaderService } from '@lib-shared/loader/services/loader.service';

import { IconPreloadComponent } from '../../../../lib-shared/material/components/icon-preload/icon-preload.component';

@Component({
  selector: 'app-layout-core',
  templateUrl: './layout-core.component.html',
  styleUrls: ['./layout-core.component.scss'],
  standalone: true,
  imports: [RouterOutlet, IconPreloadComponent],
})
export class LayoutCoreComponent implements OnInit, OnDestroy {
  // subscriptions
  private subscriptions: Subscription = new Subscription();

  /**
   * constructor
   *
   */
  constructor(
    private globalStoreService: GlobalStoreService,
    private loaderService: LoaderService,
  ) {}

  /**
   * ngOnInit
   *
   */
  ngOnInit(): void {
    // subscribe to globalStoreService getShowLoading
    this.subscriptions.add(
      this.globalStoreService
        .getShowLoading()
        .pipe(
          tap((loading: boolean) => {
            if (loading) {
              this.loaderService.open();
            } else {
              this.loaderService.close();
            }
          }),
        )
        .subscribe(),
    );
  }

  /**
   * ngOnDestroy
   *
   */
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
